export const themeTheme = process.env.Default;
export const themeLogo = process.env.;

export default {
  themeTheme,
  themeLogo
};